<template>
    <v-container id="about">
        <h1>About</h1>

        <br/>

        <h2>How do I find places?</h2>
        <p>
            From the
            <router-link to="/">front page</router-link>
            you can either find places close to you now (using your device's location), or search for places in a
            specific city.
        </p>
        <p>We will be improving the search feature with time to allow searching near landmarks and near a specific address.</p>
        <p>Nomad Office is new, and the more reviews places have the more useful it will be. If you use Nomad Office to find a place to work remember to help out fellow travellers by leaving a review.</p>

        <h2>How do I submit places?</h2>
        <p>You can <router-link to="/new-place">add a new place</router-link> by searching for places nearby or manually entering an address.</p>
        <p>We will be improving the add feature with time to allow searching near landmarks and near a specific address.</p>
    </v-container>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
    name: 'AboutView',
});
</script>
